/*
 * Copyright (c) 2024. Haodong JU
 */
import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { reservationLocalHost } from '@/model/dataLayer/api/newReservation/reservation'

const url = reservationLocalHost + '/settings/weeklySetting/'

export async function saveWeeklySettings (item) {
  return (await hillo.jsonPost(url + 'save', {
    ...item,
    deviceId: await getCurrentDeviceId()
  }))
}

export async function deleteWeeklySettings (id) {
  return (await hillo.post(`${url}${id}/delete`, {}))
}

export async function getWeeklySettings () {
  return (await hillo.get(url + await getCurrentDeviceId(), {})).data
}

/**
 * 全部营业时段（含带生效日期的那几套，cloud #437 的 /all）。
 * 后端没有 /all 时（老版本回 404）退回老接口，supportsEffectiveDate = false：这时不让建带日期的那套。
 * @return {Promise<{list: Array, supportsEffectiveDate: boolean}>}
 */
export async function getAllWeeklySettings () {
  const deviceId = await getCurrentDeviceId()
  const res = await hillo.silentGet(url + deviceId + '/all', {})
  if (res?.code === 200 && Array.isArray(res.data)) {
    return { list: res.data, supportsEffectiveDate: true }
  }
  // 老接口也取不到（断网、5xx、连不上云）时抛错，页面不能把「空」当成「没设置过」去显示默认时段
  const old = await hillo.silentGet(url + deviceId, {})
  if (old?.code === 200 && Array.isArray(old.data)) {
    return { list: old.data, supportsEffectiveDate: false }
  }
  throw new Error(old?.message || 'weeklySetting load failed')
}
